import { useGetUserLimits } from '../useGetUserLimits';

export const useUserHasPremiumFilterAccess = () => {
  const { premiumFilters } = useGetUserLimits();

  return Boolean(premiumFilters);
};
